import { object } from '@hapi/joi';
import { CommonGet, CommonPost } from '../../../utils/CommonFetch';

export default {
    saveData,
    editData,
    getGroups,
    getDeductionTypes,
    getApplyMethods,
    getAllOperationEntitiesForDropDown,
    getAvailableCollectionPointByDeductionType,
    getAllCollectionCategoryMenusForDropdown,
    getAssignedCollectionPointByDeductionType,
};

async function saveData(result) {

    let deduction = {
        bulkDeductions: result
    }
    var result = await CommonPost('/api/DeductionTemplate/InsertBulkDeductionTemplate', null, deduction);
    return result;
}

async function editData(result) {
    let deduction = {
        bulkDeductions: result
    }
    var result = await CommonPost('/api/DeductionTemplate/UpdateBulkDeductionTemplate', null, deduction);
    return result;
}

async function getGroups() {
    let response = await CommonGet('/api/Group/GetAllGroups', null);
    let groupArray = []
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true) {
            groupArray[item[1]["groupID"]] = item[1]["groupName"]
        }
    }
    return groupArray;
}

async function getApplyMethods() {
    var response = await CommonGet('/api/EnumData/GetApplyMethodEnumData', null);
    var array = []
    for (let item of Object.entries(response.data)) {
        array[item[1]["key"]] = item[1]["value"]
    }
    return array;
}

async function getDeductionTypes() {
    var response = await CommonGet('/api/DeductionType/GetAllDeductionTypes', null);
    var array = []
    for (let item of Object.entries(response.data)) {
       if (item[1]["isActive"] === true) {
           array[item[1]["deductionTypeID"]] = item[1]["deductionTypeName"]
       }
    }
    return array;
}

async function getAllOperationEntitiesForDropDown(id) {
    var operationEntityArray = [];
    var response = await CommonGet('/api/OperationEntity/GetOperationEntityByGroupIDEntityID', 'groupID=' + id);
    for (let item of Object.entries(response.data)) {
        operationEntityArray[item[1]["operationEntityID"]] = item[1]["operationEntityName"];
    }
    return operationEntityArray;
}

async function getAvailableCollectionPointByDeductionType(groupID, operationEntityID, collectionCategoryMenuID, deductionTypeID) {
    var response = await CommonGet('/api/CollectionPoint/GetAvailableCollectionPointByDeductionType', 'groupID=' + groupID + '&operationEntityID=' + operationEntityID +'&collectionCategoryMenuID=' + collectionCategoryMenuID+ '&deductionTypeID=' + deductionTypeID);
    return response.data;
}

async function getAssignedCollectionPointByDeductionType(groupID, operationEntityID, collectionCategoryMenuID, deductionTypeID) {
    var response = await CommonGet('/api/CollectionPoint/GetAssignedCollectionPointByDeductionType', 'groupID=' + groupID + '&operationEntityID=' + operationEntityID +'&collectionCategoryMenuID=' + collectionCategoryMenuID+ '&deductionTypeID=' + deductionTypeID);
    return response.data;
}

async function getAllCollectionCategoryMenusForDropdown(collectionCategoryID) {
    let collectionCategoryMenuArray = []
    var response = await CommonGet('/api/CollectionCategory/GetCollectionCategoryMenusByCollectionCategoryID', 'collectionCategoryID=' + collectionCategoryID);
    
    for (let item of Object.entries(response.data)) {
            collectionCategoryMenuArray[item[1]["collectionCategoryMenuID"]] = item[1]["menuName"]
    }
    return collectionCategoryMenuArray;

}

